//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { CategoryAlreadyExistsMessage } from './category-already-exists.message';

@PresenterType(
{
    model: CategoryAlreadyExistsMessage
})
@Component({
    selector: 'category-already-exists-message-template',
    templateUrl: './category-already-exists-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CategoryAlreadyExistsMessageTemplateComponent
{
    public data: WritableSignal<CategoryAlreadyExistsMessage>;
    
    constructor() {
        this.data = signal<CategoryAlreadyExistsMessage>(null);
    }
}